<div [class]="(disabled ? 'disabled ' : '') + 'chip-wrapper'">
	@if (labelInput) {
		<p>{{ labelInput }}</p>
	}
	<ng-content />
	@if (onDelete) {
		<mat-icon class="material-icons-outlined icon" (click)="handleDelete($event)">clear</mat-icon>
	}
</div>
